// Service performance (approved HTML component: service-performance).
import type { ReactNode } from 'react';
import type { HealthStat } from '../mockData.js';
import { HealthGrid } from './HealthGrid.js';

export interface ServicePerformanceProps {
  stats: HealthStat[];
  snapshot: string;
}

export function ServicePerformance({
  stats,
  snapshot,
}: ServicePerformanceProps): ReactNode {
  return (
    <HealthGrid
      title="Service performance"
      subtitle={snapshot}
      stats={stats}
      dataComponent="service-performance"
    />
  );
}
